var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#7292F7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 7.55556L15.231 8.80889L17.553 11.1111H8.4V12.8889H17.553L15.231 15.1822L16.5 16.4444L21 12L16.5 7.55556ZM4.8 5.77778H12V4H4.8C3.81 4 3 4.8 3 5.77778V18.2222C3 19.2 3.81 20 4.8 20H12V18.2222H4.8V5.77778Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.dc3f585c83a40b6fade46ac28fd3cb61.svg";
export { ForwardRef as ReactComponent };